export default __webpack_public_path__ + "static/media/content-5.344f1003.jpg";